// test2579
(2579 && 0);
